<template>
  <div class="bodybg">
    <div class="wrap">
      <div class="container">
        <!-- <div class="logo">
          <el-link :underline="false">
            <router-link :to="{ path: '/' }">
              <img width="130px" src="@/assets/images/logo.png" />
            </router-link>
          </el-link>
        </div> -->
        <div class="main">
          <Header />
          <slot name="banner"></slot>
          <div class="main_list">
            <div class="main_box_left">
              <slot name="mainBox"></slot>
            </div>
            <!-- <div class="main_box_right">
              <div class="main_box_r_wx">
                <img src="@/assets/images/qrcode.png" />
                <slot name="Wxp"></slot>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <el-backtop></el-backtop>
    <Footer>
      <template v-slot:footerImage>
        <slot name="footerImage"></slot>
      </template>
    </Footer>
  </div>
</template>

<script>
import Header from "./Header.vue";
import Footer from "./Footer.vue";
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      activeMenu: null
    };
  },
  created() {
    localStorage.setItem("newIndex", 1);
    // window.onscroll = () => {
    //   this.scroll();
    // };
  },
  methods: {
    goTo(url, index, id) {
      this.$router.push({ path: url, query: { indexs: index, id: id } });
    }
  }
};
</script>
<style scoped>
.bodybg {
  width: 100%;
  height: 100%;
  background: #000;
  color: #fff;
  overflow: hidden;
  /* background-color: rgba(0, 0, 0, 0.6); 
  backdrop-filter: blur(10px);  */
  /* overflow-y: scroll; */
}

.wrap {
  width: 100%;
  max-width: 1440px;
  margin: 0px auto;
  overflow: hidden;
  padding: 0 20px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  min-height: calc(100vh - 58px);
  /* display: flex; */
}

.logo {
  width: 170px;
  padding-top: 95px;
  padding-left: 30px;
  display: inline-block;
}

.main {
  /* width: 1240px; */
  height: 100%;
  width: 100%;
}

.main_list {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
}

.main_box_left {
  /* width: 1040px; */
  /* width: 960px; */
  float: left;
  height: 100%;
  width: 100%;
}

.main_box_right {
  float: right;
  width: 160px;
  height: auto;
  padding-top: 10px;
}

.main_box_r_wx,
.main_box_r_wap {
  margin-top: 10px;
}

.main_box_r_wx img {
  width: 145px;
  height: 145px;
}

.main_box_r_wx p {
  font-size: 14px;
  color: #fff;
  text-align: center;
  padding: 10px 0;
}

.main_list_ol {
  margin-top: 20px;
  display: flex;
}

</style>



// WEBPACK FOOTER //
// src/components/CommonPage.vue